export default {
    props: {
        postId: String,
        perPage: {
            type: Number,
            default: 10
        },
        user: Object,
        options: Object,
        tags: Array,
        statusActive: {
            type: String,
            default: 'active'
        },
        statusModeration: {
            type: String,
            default: 'moderation'
        },
        statusDeleted: {
            type: String,
            default: 'deleted'
        },
        moderable: {
            type: Boolean,
            default: false
        },
        level: {
            type: Number,
            default: 0
        },
        depth: {
            type: Number,
            default: 0
        },
        activity: {
            type: Object,
            default: null
        },
        messageCounter: {
            type: Number,
            default: 10
        }
    }
}
